import axios from "axios"
import { post, del, get, getResources, getFreebieData, postStripeInfo, getStripeInfo, put } from "./api_helper"
import * as url from "./url_helper"
import { Auth } from 'aws-amplify';


const getToken = () => {
  const token = localStorage.getItem("token")
  return token
}

const getLoggedInUser = () => {
    const user = localStorage.getItem("user")
    if (user)
	return JSON.parse(user).user
}

const logoutUser = async () => {
  // Clear local state first: the signOut call below used to sit above these two
  // lines, which made them unreachable, so a stale `user` survived every logout
  // and failed auth check while `token` did not.
  localStorage.removeItem("user")
  localStorage.removeItem("token")
  try {
    await Auth.signOut({ global: true });  // This clears the session globally
  } catch (err) {
    // Already signed out, or the global sign-out failed. Local state is cleared
    // either way, which is what callers depend on.
  }
}

// --- Journal / Notes (new endpoints) ---
// -----------------------------
// Journal / Notes helpers (NEW)
// -----------------------------

// GET #1: list days with notes
export const getJournalDays = username =>
    get(`${url.GET_JOURNAL_DAYS}?username=${username}`, {
        headers: { Authorization: getToken() },
    })

// GET #2: fetch notes for a specific day (YYYY-MM-DD)
export const getJournalByDay = (username, day) =>
    get(`${url.GET_JOURNAL_BY_DAY}?username=${username}&date=${day}`, {
        headers: { Authorization: getToken() },
    })

// GET #3: search notes across all days (timeline)
export const searchJournalNotes = ({ username, area_id, plant_id, start_date, end_date } = {}) => {
    const qs = new URLSearchParams({ username });
    if (area_id)    qs.set("area_id", area_id);
    if (plant_id)   qs.set("plant_id", plant_id);
    if (start_date) { qs.set("start_date", start_date); qs.set("end_date", end_date); }
    return get(`${url.GET_JOURNAL_SEARCH}?${qs.toString()}`, {
        headers: { Authorization: getToken() },
    });
}

// CREATE (POST)
export const postJournalEntry = data =>
    post(url.POST_JOURNAL_ENTRY, data, {
        headers: { Authorization: getToken() },
    })

// UPDATE (PUT)
export const putJournalEntry = data =>
    put(url.UPDATE_JOURNAL_ENTRY, data, {
        headers: { Authorization: getToken() },
    })

// DELETE
export const deleteJournalEntry = noteId => {
    const username = getLoggedInUser() || "";
    return del(`${url.DELETE_JOURNAL_ENTRY}?note_id=${noteId}&username=${username}`, {
        headers: { Authorization: getToken() },
    });
}

// ------------------------------------
// Backward-compatible aliases (OPTIONAL)
// ------------------------------------
// These prevent old code from breaking (postNote/deleteNote/getNote)
export const postNote = data => postJournalEntry(data)
export const deleteNote = id => deleteJournalEntry(id)
export const getNote = id => getJournalEntry(id)


// Register Method
export const createCognitoUser = user => {
  console.log(user)
  return signUp(user.username, user.password, user.email);
}

export const subscribeOnboardSequence = user => {
    postStripeInfo("/onboard-user", user)
}

export const createSageUser = user => {
  console.log(user)
  return post(url.CREATE_NEW_USER, user,  { headers: { "Authorization": getToken()} })
}

export const createStripeCustomer = profile => {
  console.log(profile)
  return post(url.CREATE_STRIPE_CUSTOMER, profile,  { headers: { "Authorization": getToken()} })
}

function signUp(username, password, email) {
  try {
      return Auth.signUp({
            username,
            password,
            attributes: {
               email,     
            }
      });
  } catch (error) {
       console.log('error signing up:', error);
  }
}

// Login Method
const postLogin = data => {
  return login(data.username, data.password)
}

async function login(username, password) {
  return Auth.signIn(username, password);
}

const addToken = user => {
  var expireDate = new Date();
  expireDate.setHours( expireDate.getHours() + 4 );
  const email = user.signInUserSession.idToken.payload.email;
  var userInfo = {
     "user": email || user.username,
     "expireSession": expireDate.getTime()
  }
  userInfo = JSON.stringify(userInfo)
  localStorage.setItem("user",userInfo)
  localStorage.setItem("token", user.signInUserSession.idToken.jwtToken)
}

const fetchProfile = (username) => {
	return get(`${url.PROFILE}`, { headers: { "Authorization": getToken()},
		          params: { username } })
}
// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data)

// Edit profile
export const postProfile = profile => {
    return post(url.PROFILE, profile.profile, { headers: { "Authorization": getToken()} })
}
 

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data)

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      let message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err[1]
            break
        }
      }
      throw message
    })
}

// Login Method
const postJwtLogin = data => post(url.POST_FAKE_JWT_LOGIN, data)

// postForgetPwd
const postJwtForgetPwd = user => { 
  return Auth.forgotPassword(user);
}

const postJwtChangePwd = (user, code, password) => {
  console.log("SDFSFDS")
  return Auth.forgotPasswordSubmit(user, code, password) 
}

const postConfirmEmail = (user,code) => {
  return Auth.confirmSignUp(user, code);
}

export const changePassword = (oldPassword, newPassword) => {
  Auth.currentAuthenticatedUser()
      .then((user) => {
        return Auth.changePassword(user, oldPassword, newPassword)
      })
}

export const logUserActivity = user => put(url.POST_USER_LOGIN, 
	{ 
		"username": user
	},
        { headers: {"Authorization" : getToken()} })


// get Products
export const getProducts = () => get(url.GET_PRODUCTS)

// get Product detail
export const getProductDetail = id =>
  get(`${url.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } })

// affiliate
export const getReferral = username =>
  get(`${url.GET_REFERRAL}?username=${username}`, { headers: { "Authorization": getToken()},
	 params: { username } })

export const addReferral = referral => {
     console.log(referral)
	post (url.ADD_REFERRAL, referral, { headers: {"Authorization" : getToken()} })

}
export const updateReferral = referral => {
  put (url.UPDATE_REFERRAL, referral, { headers: { "Authorization": getToken()} })
}

// get Events
export const getEvents = username =>
  get(`${url.GET_EVENTS}?username=${username}`, { headers: { "Authorization": getToken()},
	  params: { username } })

// add Events
export const addNewEvent = event => post(url.ADD_NEW_EVENT, event,  { headers: { "Authorization": getToken()} })

// update Event
export const updateEvent = event => {
	console.log(event);
	put(url.UPDATE_EVENT, event, { headers: { "Authorization": getToken()} })
}

// delete Event
export const deleteEvent = eventId =>
  del(`${url.DELETE_EVENT}?id=${eventId}`,  { headers: { "Authorization": getToken()} })

// delete Monthly Events
export const deleteMonthEvents = events => post(url.DELETE_MONTH_EVENTS, events,  { headers: { "Authorization": getToken()} })

export const getDesigns = username =>
	  get(`${url.GET_DESIGNS}?username=${username}`, { headers: { "Authorization": getToken()},
		            params: { username } })

export const searchPlants = search => 
    get(`${url.PLANT_SEARCH}`, { headers: { "Authorization": getToken()},
	    params: { search } })

export const searchStructures = search =>
    get(`${url.STRUCTURES_SEARCH}`, { headers: { "Authorization": getToken()},
        params: { search } })

export const searchResources = search =>
    getResources({params: { search } })

export const fetchDataEntryPlants = () =>
          get(`${url.GET_DATAENTRY_PLANTS}`, { headers: { "Authorization": getToken()} })

export const fetchDataEntryAnimals = () =>
          get(`${url.GET_DATAENTRY_ANIMALS}`, { headers: { "Authorization": getToken()} })

export const fetchLeaderboard = () =>
          get(`${url.GET_LEADERBOARD}`, { headers: { "Authorization": getToken()} })

export const saveDataEntryPlant = plant => post(url.ADD_DATAENTRY_PLANT, plant,  { headers: { "Authorization": getToken()} })

export const saveDataEntryAnimal = animal => post(url.ADD_DATAENTRY_ANIMAL, animal,  { headers: { "Authorization": getToken()} })


export const getObjectives = username =>
          get(`${url.GET_OBJECTIVES}?username=${username}`, { headers: { "Authorization": getToken()},
                            params: { username } })

export const getAreas = username =>
          get(`${url.GET_AREAS}`, { headers: { "Authorization": getToken()},
                            params: { username } })

export const saveObjectives = objectives => {
                put(url.SAVE_OBJECTIVES, objectives, { headers: { "Authorization": getToken()} })
}

export const addArea = area => post(url.ADD_AREA, area,  { headers: { "Authorization": getToken()} })

export const searchGuild = searchGuildParams => get(`${url.SEARCH_GUILD}?guildFunction=${searchGuildParams.guildFunction}&layer=${searchGuildParams.layer}&climate=${searchGuildParams.climate}&zone=${searchGuildParams.zone}`, { headers: {"Authorization": getToken() } })

export const getUserGuilds = username =>
          get(`${url.GET_USER_GUILDS}`, { headers: { "Authorization": getToken() }, params: { username } })

export const createUserGuild = guild =>
          post(url.CREATE_USER_GUILD, guild, { headers: { "Authorization": getToken() } })

export const updateUserGuild = guild =>
          put(url.UPDATE_USER_GUILD, guild, { headers: { "Authorization": getToken() } })

export const deleteUserGuild = id =>
          del(`${url.DELETE_USER_GUILD}?id=${id}`, { headers: { "Authorization": getToken() } })

export const updateArea = area => {
                console.log(area);
                put(url.UPDATE_AREA, area, { headers: { "Authorization": getToken()} })
}

export const deleteCustomPlant = id =>
          del(`${url.DELETE_CUSTOM_PLANT}?id=${id}`,  { headers: { "Authorization": getToken()} })

export const fetchCustomPlants = username =>
          get(`${url.GET_CUSTOM_PLANTS}`, { headers: { "Authorization": getToken()},
                            params: { username } })

export const postCustomPlant = plant =>
                post(url.SAVE_CUSTOM_PLANT, plant, { headers: { "Authorization": getToken()} })

export const updateCustomPlant = plant =>
                put(url.UPDATE_CUSTOM_PLANT, plant, { headers: { "Authorization": getToken()} })

export const deleteArea = id =>
          del(`${url.DELETE_AREA}?id=${id}`,  { headers: { "Authorization": getToken()} })

export const addDesign = design => post(url.ADD_DESIGN, design,  { headers: { "Authorization": getToken()} })


export const checkUserExists = async (username) => {
  try {
    await Auth.signIn(username, "fakePassword123!")
  } catch (err) {
    if (err.code === "NotAuthorizedException") {
      return false
    }
    return true   // user exists (bad password, unconfirmed, etc.)
  }
}

export const updateDesign = design => {
	        console.log(design);
	        put(url.UPDATE_DESIGN, design, { headers: { "Authorization": getToken()} })
}


export const deleteDesign = designId =>
	  del(`${url.DELETE_DESIGN}?id=${designId}`,  { headers: { "Authorization": getToken()} })

export const saveClimateData = climate => post (url.SET_CLIMATE_DATA, climate, { headers: { "Authorization": getToken()} })


export const getClimateData = zipcode =>
          get(`${url.GET_CLIMATE_DATA}?zipcode=${zipcode}`, { headers: {"Authorization": getToken() } })

export const getCustomClimate = user =>
          get(`${url.GET_CUSTOM_CLIMATE}?user=${user}`, { headers: {"Authorization": getToken() } })


export const getPlantData = () =>
	get (url.GET_PLANT_DATA, { headers: {"Authorization": getToken() } })

export const getStructureData = () =>
    get (url.GET_STRUCTURE_DATA, { headers: {"Authorization": getToken() } })

export const getFreebieClimateData = zipcode =>
    getFreebieData(`${url.GET_FREEBIE_CLIMATE_DATA}?zipcode=${zipcode}`)

export const getFreebiePlantData = () =>
    getFreebieData(`${url.GET_FREEBIE_PLANT_DATA}`) 

// get Categories
export const getCategories = () => get(url.GET_CATEGORIES)

// get chats
export const getChats = () => get(url.GET_CHATS)

// get groups
export const getGroups = () => get(url.GET_GROUPS)

// get Contacts
export const getContacts = () => get(url.GET_CONTACTS)

// get messages
export const getMessages = (roomId = "") =>
  get(`${url.GET_MESSAGES}/${roomId}`, { params: { roomId } })

// post messages
export const addMessage = message => post(url.ADD_MESSAGE, message)

// get orders
export const getOrders = () => get(url.GET_ORDERS)

// get cart data
export const getCartData = () => get(url.GET_CART_DATA)

// dashboard actions
export const getDashboard = () => get(`${url.GET_DASHBOARD}`,  { headers: { "Authorization": getToken()} })

export const addDashboardItem = (item) => post(url.ADD_DASHBOARD_ITEM, item, { headers: { "Authorization": getToken()} })

export const deleteDashboardItem = (id) =>  del(`${url.DELETE_DASHBOARD_ITEM}?id=${id}`,  { headers: { "Authorization": getToken()} }) 

// get customers
export const getCustomers = () => get(url.GET_CUSTOMERS)

// get shops
export const getShops = () => get(url.GET_SHOPS)

// get wallet
export const getWallet = () => get(url.GET_WALLET)

// get crypto order
export const getCryptoOrder = () => get(url.GET_CRYPTO_ORDERS)

// get invoices
export const getInvoices = () => get(url.GET_INVOICES)

// get invoice details
export const getInvoiceDetail = id =>
  get(`${url.GET_INVOICE_DETAIL}/${id}`, { params: { id } })

// get tasks
export const getTasks = () => get(url.GET_TASKS)

// get tasks
export const getPrizes = () => 
 get(`${url.GET_PRIZES}`,  { headers: { "Authorization": getToken()} })

export const getRedemptionsActivity = (username) =>
 get(`${url.GET_REDEMPTIONS_ACTIVITY}?username=${username}`,  { headers: { "Authorization": getToken()} })

export const addRedemption = redemption => post(url.ADD_REDEMPTION, redemption,  { headers: { "Authorization": getToken()} })

export const updateRedemption = redemption => put (url.UPDATE_REDEMPTION, redemption, { headers: { "Authorization": getToken()} })

export const addActivity = activity => post(url.ADD_ACTIVITY, activity,  { headers: { "Authorization": getToken()} })

// get contacts
export const getUsers = () => 
  get(`${url.GET_USERS}`,  { headers: { "Authorization": getToken()} })

export const getUserProfile = () => get(url.GET_USER_PROFILE)

export const getAccountInfo = (customer_id) => {
    return postStripeInfo("/stripe-session", customer_id)
}
export const getSubscriptions = () =>
    getStripeInfo("/subscriptions") 
export const createStripeUser = (user) =>
    postStripeInfo("/create-register-session", user)
export const getRegisterPassword = (password) => {
    console.log(password)
    return postStripeInfo("/get-register-password", password)
}
export const getCustomerId = (sessionId) => {
    console.log(sessionId)
    return getStripeInfo("/get-customer-id?id="+sessionId)
}


export {
  logoutUser,
  getLoggedInUser,
  postLogin,
  addToken,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtChangePwd,
  postConfirmEmail,
  fetchProfile
}
